import { useQuery } from "@tanstack/react-query";
import { stockApi } from "@/lib/stock.api";
import { queryKeys } from "@/lib/query-keys";

export type StockEditRequestStatusFilter = "all" | "pending" | "approved" | "rejected";

export function useStockEditRequests(status: StockEditRequestStatusFilter = "pending") {
  return useQuery({
    queryKey: queryKeys.stockEditRequests(status),
    queryFn: () =>
      status === "all"
        ? stockApi.listAllEditRequests().then((r) => r.data)
        : stockApi.listEditRequests(status).then((r) => r.data),
  });
}
